/* eslint-disable */
/**
 * Utility functions for converting error codes and action types to MSGs
 */

// Map of action types to MSGs
const actionTypeErrorMessages = {
  'approvals/putApproval/rejected': 'Failed to process company approval',
  'approvals/getApprovals/rejected': 'Failed to load approvals list',
  'approvals/getAvailablePlans/rejected': 'Failed to load available plans',
  'approvals/getApprovalAvailableAccessRight/rejected': 'Failed to load access rights',
};

// Map of API error codes to MSGs
const apiErrorMessages = {
  'error.ERROR_SUBSCRIBE_FAILED': 'Subscription failed. Please try again.',
  'error.ERROR_USER_SUBSCRIBED': 'User is already subscribed to this service.',
  'error.ERROR_INVALID_REQUEST': 'Invalid request. Please check your input and try again.',
  'error.ERROR_UNAUTHORIZED': 'You are not authorized to perform this action.',
  'error.ERROR_FORBIDDEN': 'Access denied. You do not have permission for this action.',
  'error.ERROR_ACCESS_DENIED': 'Access denied. You do not have permission for this action.',
  'error.ERROR_NOT_FOUND': 'The requested resource was not found.',
  'error.ERROR_INTERNAL_SERVER': 'An internal server error occurred. Please try again later.',
  'error.ERROR_BAD_REQUEST': 'Bad request. Please check your input and try again.',
  'error.ERROR_VALIDATION_FAILED': 'Validation failed. Please check your input and try again.',
  'error.ERROR_COMPANY_NOT_FOUND': 'Company not found.',
  'error.ERROR_PLAN_NOT_FOUND': 'Selected plan not found.',
  'error.ERROR_INVALID_STATUS': 'Invalid approval status.',
  'error.ERROR_APPROVAL_ALREADY_PROCESSED': 'This approval has already been processed.',
  'error.ERROR_INSUFFICIENT_PERMISSIONS': 'You do not have sufficient permissions for this action.',
  'error.ERROR_USER_NOT_FOUND': 'User not found.',
  'error.ERROR_USER_VERIFIED_BEFORE': 'User has already been verified.',
  'error.ERROR_INVALID_PIN': 'Invalid PIN. Please try again.',
  'error.ERROR_INVALID_SURVEY_EXPIRED': 'This survey has expired.',
  'error.ERROR_DUPLICATE_EMAIL': 'This email address is already in use.',
  'error.ERROR_INVALID_PDF_FILE': 'Invalid PDF file. Please select a valid PDF file.',
  'error.ERROR_FILE_EXCEED_LIMIT': 'File size exceeds the allowed limit.',
  'error.ERROR_VOID_REASON_NOT_SELECT': 'Please select a reason for voiding.',
  'error.ERROR_REJECT_REASON_NOT_SELECT': 'Please select a reason for rejection.',
};

/**
 * Convert action type to MSGs
 * @param {string} actionType - Redux action type (e.g., 'approvals/putApproval/rejected')
 * @returns {string}
 */
export function getActionTypeErrorMessage(actionType) {
  return actionTypeErrorMessages[actionType] || 'An error occurred. Please try again.';
}

/**
 * Convert API error code to MSGs
 * @param {string} errorCode - API error code (e.g., 'error.ERROR_SUBSCRIBE_FAILED')
 * @returns {string}
 */
export function getApiErrorMessage(errorCode) {
  return apiErrorMessages[errorCode] || 'An unexpected error occurred. Please try again.';
}

/**
 * Extract and convert error from API response or action payload
 * @param {object} error - Error object from API response or action payload
 * @returns {string}
 */
export function getErrorMessage(error) {
  if (error && error.code) {
    return getApiErrorMessage(error.code);
  }

  if (error && error.data) {
    try {
      const parsedData = typeof error.data === 'string' ? JSON.parse(error.data) : error.data;
      if (parsedData && parsedData.code) {
        return getApiErrorMessage(parsedData.code);
      }
    } catch (e) {
    }
  }

  if (error && error.message) {
    return error.message;
  }

  // Default fallback message
  return 'An unexpected error occurred. Please try again.';
}
